<h2 mat-dialog-title>Update title</h2>

<mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <mat-form-field>
      <mat-label>Title</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        formControlName="title"
        placeholder="Title"
        class="title-textarea"
        rows="1"
      ></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeDialog()">Cancel</button>
  <button mat-raised-button color="primary" (click)="sendUpdateTitle()">
    Update
  </button>
</mat-dialog-actions>
